"use strict";
import "stylesheets/comments.scss";
import "src/decidim/comments/comments";
import "src/decidim/comments/comments_mobile_modal";
import { definitionsFromContext } from "src/decidim/refactor/support/stimulus";
const context = require.context("src/decidim/comments/controllers", true, /controller\.js$/);
window.Stimulus.load(definitionsFromContext(context));
